import React from 'react';
import genStyles from '../generale.module.css';

export default function ConfirmSaveForm({ onClose, onValidate }) {
    

    return (
        <div className="row">
            <p className="center-align font_size_22">
                Attention, vous n'avez pas enregistré les modifications que vous avez apportées. 
            </p>
            <div className={genStyles.buttonfooter}>
                <button
                className="btn red lighten-1 z-depth-0 mr5 ml5"
                style={{ width: '40%' }}
                onClick={onClose}
                >
                Quiter sans enregistrer
                </button>
                <button
                className="btn green lighten-1 z-depth-0 mr5 ml5"
                style={{ width: '40%' }}
                onClick={onValidate}
                >
                Enregistrer et quitter
                </button>
            </div>
        </div>
    );
}
